import { Component, EventEmitter, HostListener, Input, OnInit, Output, } from '@angular/core'
import { StringHelper } from '../../../../core/helpers/strings.helper'
import { MoniepointColumnType, MoniepointSpecialTableColumn, } from '../../../../shared/models/moniepoint-table.model'
import * as moment from 'moment'
import { GreyIconType } from '../../../../lean-icons/grey-icons/grey-icons.component';

@Component({
	selector: 'app-moniepoint-table',
	templateUrl: './moniepoint-table.component.html',
	styleUrls: ['./moniepoint-table.component.scss'],
})
export class MoniepointTableComponent implements OnInit {
	@Output() emitRowClicked = new EventEmitter();
	@Output() emitEmptyStateFunction = new EventEmitter();
	@Output() changePage = new EventEmitter();
	@Output() emitRetryClicked = new EventEmitter();
	@Input() canViewDetails: boolean;
	@Input() useAlternativeDetailsView: boolean;
	@Input() errorMessage: string;
	@Input() hasFullMobileColumns: string;
	@Input() totalWordCount: number;
	@Input() isMobileEmptyStateCard: boolean;
	@Input() itemList: any[];
	@Input() viewIconReplacementText: string;
	@Input() replaceTextStyle: string;
	@Input() keyIdentifierName: string;
	@Input() breakPoint: number;
	@Input() mobileTableTitles: any;
	@Input() basicPagination: boolean;
	@Input() minWidth: number;
	@Input() icon_type: Icon_TYPE;
	minTableWidth: string;
	headers: string[];
	mobileHeader: string[];
	readonly KEY = 'keyIdentifier';
	mobileHeaders: string[];
	mobileHeaderValues: string[];
	@Input() specialColumns: MoniepointSpecialTableColumn[];
	@Input() rows: any[];
	@Input() rowArray: any[];
	@Input() pageNumber: number;
	@Input() totalItems: number;
	@Input() showPagination: boolean;
	@Input() device: Device;
	fullMobileColumns = [];
	readonly OLD_TABLE: TableType = 'OLD';
	readonly NEW_TABLE: TableType = 'NEW';
	readonly WEB: Device = 'WEB';
	readonly MOBILE: Device = 'MOBILE';
	readonly REFINED_POS: Mobile_Table_TYPE = 'refined-pos';
	readonly REFINED_TRANSACTION: Mobile_Table_TYPE = 'refined-transaction';
	readonly REFINED_SUMMARY: Mobile_Table_TYPE = 'refined-summary';
	readonly REFINED_DEVICE: Mobile_Table_TYPE = 'refined-device';
	readonly REFINED_DEVICE_V2: Mobile_Table_TYPE = 'refined-device-v2';
	@Input() tableRows: RowAdaptor[];
	mobileTableRows: RowAdaptor[];
	@Input() tableType: TableType;
	@Input() totalPages: number;
	@Input() emptyStateText: string;
	readonly DEFAULT_EMPTY_STATE_TEXT = 'You have no item ...yet';
	@Input() emptyIcon: string;
	@Input() emptyStateLabel: string;
	@Input() mobileTableType: Mobile_Table_TYPE;
	isMobile: boolean;
	readonly COL_24 = 24;
	readonly COL_12 = 12;

	constructor() {
	}

	ngOnInit(): void {
		this.initialize();
	}

	@HostListener('window:resize', ['$event'])
	onResize(_event): void {
		this.setMobile(window.innerWidth)
	}

	setMobile(browserWidth: number) {
		this.isMobile = browserWidth <= this.breakPoint
	}

	getTableSize() {
		if (this.tableType === 'NEW') {
			return this.tableRows.length
		}
		return this.rows.length;
	}

	initialize() {
		try {
			this.setMobile(window.innerWidth);
			if (!this.tableType) {
				this.tableType = this.OLD_TABLE;
			}
			if (!this.emptyStateText) {
				this.emptyStateText = this.DEFAULT_EMPTY_STATE_TEXT
			}
			if (!this.device) {
				this.device = this.WEB
			}
			if (this.hasFullMobileColumns) {
				this.fullMobileColumns = this.hasFullMobileColumns.split(',');
			}
			if (this.showPagination === undefined) {
				this.showPagination = true;
			}
			if (!this.keyIdentifierName) {
				this.keyIdentifierName = 'id'
			}
			if (!this.icon_type) {
				this.icon_type = 'colored'
			}
			if (!this.breakPoint) {
				this.breakPoint = 768
			}
			if (!this.mobileTableType) {
				this.mobileTableType = 'refined-transaction'
			}
			this.headers = [];
			this.mobileHeader = [];
			this.mobileHeaderValues = [];
			this.mobileHeaders = [];
			if (!this.errorMessage) {
				if (this.rows?.length) {
					this.headers = StringHelper.getObjectPropNameAsArray(
						this.rows[0]
					);
				}
				if (this.mobileTableTitles) {
					this.setMobileHeader();
					this.mobileHeaders = StringHelper.getObjectPropNameAsArray(
						this.filterMobileArr(this.rows[0])
					);
				}
			}
		}
		catch (err) {
			console.log('err ', err);
		}
	}

	setMobileHeader() {
		this.mobileHeader = this.mobileTableTitles.split(',');
	}

	getMobileHeaderValue(obj, name) {
		return '';
		// return StringHelper.getObjectValueWithPropNameFromObj(obj, name);
	}

	getMobileRows() {
		const newRows = [];
		this.rows.forEach((e) => {
			newRows.push(this.filterMobileArr(e));
		});
		return newRows;
	}

	hasFullColumn(title) {
		const hasFullColumn = this.fullMobileColumns.includes(title);
		if (hasFullColumn) {
			return this.COL_24;
		}
		else {
			return this.COL_12;
		}
	}

	convertToRelativeTime(date) {
		return moment(date).format('DD MMM YYYY hh:mm a');
	}

	convertObjToArr(obj) {
		return StringHelper.convertObjectModelToArray(obj)
	}

	filterMobileArr(obj) {
		const newObj = { ...obj };
		delete newObj[this.mobileHeader[0]];
		if (this.mobileHeader.length > 1) {
			delete newObj[this.mobileHeader[1]]
		}
		return newObj
	}

	isSpecialColumn(columnName: string) {
		let isSpecial = false;
		this.specialColumns?.forEach((e) => {
			if (e.columnName === columnName) {
				isSpecial = true
			}
		});
		return isSpecial;
	}

	getSpecialColumnType(columnName: string) {
		let columnType: MoniepointColumnType;
		this.specialColumns?.forEach((e) => {
			if (e.columnName === columnName) {
				columnType = e.columnType
			}
		});
		return columnType;
	}

	setMaxTableWidth() {
		if (this.minWidth) {
			this.minTableWidth = `${this.minWidth}px`;
		} else {
			this.minTableWidth = `1120px`;
		}
	}

	getSummaryList(row: any) {
		const summary = {};
		row.forEach((e) => {
			if (this.mobileTableTitles.toString().includes(e.key)) {
				summary[e.key] = e.value;
			}
		});
		return summary;
	}

	rowClicked(row: any) {
		if (this.canViewDetails) {
			if (this.useAlternativeDetailsView) {
				this.emitRowClicked.emit(row)
			} else {
				this.emitRowClicked.emit(this.getSelectItem(row[this.KEY]?.id))
			}
		}
	}

	deviceRowClicked(columns) {
		let selectColumn = '';
		columns.forEach((e) => {
			if (e.key === this.KEY) {
				selectColumn = e.value?.id
			}
		});
		this.emitRowClicked.emit(this.getSelectItem(selectColumn));
	}

	getSelectItem(id) {
		let selected = null;
		this.itemList.forEach((e) => {
			if (e[this.keyIdentifierName] === id) {
				selected = e
			}
		});
		return selected;
	}

	setChangePage($event: number) {
		this.changePage.emit($event);
	}

	getTableMap(row: any) {
	}

	getMapValue(value: any, action: number) {
		if (action) {
			return value?.value
		} else {
			return value?.key
		}
	}

	getHeaderFromMapArray(header: any, columns: any) {
		let headerValue = '';
		columns.forEach((e) => {
			if (e?.key === header) {
				headerValue = e?.value
			}
		});
		return headerValue;
	}

	getLabelFromMapArray(header: any, columns: any) {
		let headerValue = '';
		columns.forEach((e) => {
			if (e?.key === header) {
				headerValue = e?.value?.keyLabel
			}
		});
		return headerValue;
	}

	getClassFromMapArray(header: any, columns: any) {
		let headerValue = '';
		columns.forEach((e) => {
			if (e?.key === header) {
				headerValue = e?.value?.labelClass
			}
		});
		return headerValue;
	}
}

export type Icon_TYPE = 'colored' | 'grey' | 'blue' | 'icon';
export type Mobile_Table_TYPE = 'refined-device-v2' | 'refined-device' | 'refined-transaction' | 'refined-pos' | 'refined-summary';
export type Device = 'WEB' | 'MOBILE';
export type TableType = 'OLD' | 'NEW';

export interface ColumnAdaptor {
	title?: string;
	canShow: boolean;
	hideOnMobile?: boolean;
	value?: any;
	columnSpan?: number;
	specialColumn?: boolean;
	columnType?: any;
	isSymbol?: boolean;
	truncate?: number;
	columnClass?: string;
	columnColorClass?: string
	symbol?: any;
	symbolClass?: any;
	labelSymbol?: string;
	dateFormat?: string;
	greyIcon?: GreyIconType;
}

export interface TransactionTable {
	transactionAmount?: number
}

export interface SummaryTable {
	transactionCategory?: string;
	transactionType?: string;
	relativeDate?: any;
}

export interface PosTable {
	posTitle?: any;
	posStatus?: string;
	posTitleType?: any;
}

export interface DeviceTable {
	manufacturer?: string;
	actionName?: string;
	actionClass?: string;
}

export interface RowAdaptor extends TransactionTable, PosTable, SummaryTable, DeviceTable {
	columns: ColumnAdaptor[];
	objToEmit: any;
	hideDetailsBtn?: boolean;
	coloredRow?: boolean;
	specialMobileTitle?: boolean,
	mobileTitleType?: any,
	rowColorClass?: string;
	rating?: any;
}
